import React from 'react';
import Cart from '../../../Cart';
import * as S from './Styled';
import { bodyScrollFix } from '../../../../utils';

export default ({
  isLoading,
  visible,
  onPreviewItem,
  setCartModal,
  ...rest
}) => (
  <S.Cart
    title={null}
    visible={visible}
    footer={null}
    width={'auto'}
    {...rest}
    wrapClassName="cart"
    afterClose={bodyScrollFix}
  >
    <Cart onPreviewItem={onPreviewItem} setCartModal={setCartModal} />
  </S.Cart>
);
